import { useTranslation } from 'react-i18next';

type NumberProps = {
    value: number,
    hideZero?: boolean,
    options?: Intl.NumberFormatOptions | undefined;
    preset?: 'currency' | 'percent' | 'decimal';
}

export const Number = ({ value, hideZero = false, options, preset }: NumberProps) => {
    const { i18n } = useTranslation();

    if (hideZero && value === 0) {
        return null;
    }

    if (preset) {
        switch (preset) {
            case 'currency':
                // Always show two decimal places for currency
                options = { minimumFractionDigits: 2, maximumFractionDigits: 2, ...options };
                break;
            case 'percent':
                options = { minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'percent', ...options };
                break;
            case 'decimal':
                options = { style: 'decimal', ...options };
                break;
        }
    }

    return (
        <>
            {new Intl.NumberFormat(i18n.language, options).format(value)}
        </>
    );
};
